import { sortSection, switchSection, segmentedSection, chipsSection, selectSection } from '@/components/common/filterSections';
import {ViolationReason} from "@strenforcement/domain/violation";
import {
  DEFERRAL_FILTER_ALL,
  DEFERRAL_FILTER_ACTIVE,
  DEFERRAL_FILTER_NOT_ACTIVE,
  DEFERRAL_FILTER_PREVIOUS
} from '@/deferralFilters';

export default [
  sortSection({
    fieldKey: 'sort.field',
    ascendingKey: 'sort.ascending',
    options: [
      { value: 'detected', label: 'Date Detected' },
      { value: 'deferralEnded', label: 'Deferral End Date' },
      { value: 'reason', label: 'Reason' },
      { value: 'listingCount', label: 'Listings' },
      { value: 'lettersSent', label: 'Letters Sent' },
      { value: 'lettersPending', label: 'Letters Pending' }
    ],
    directionLabel(field, asc) {
      switch (field) {
        case 'detected': return asc ? 'Oldest First' : 'Newest First';
        case 'deferralEnded': return asc ? 'Oldest First' : 'Most Recent First';
        case 'reason': return asc ? 'A → Z' : 'Z → A';
        case 'listingCount': return asc ? 'Fewest First' : 'Most First';
        case 'lettersSent': return asc ? 'Fewest First' : 'Most First';
        case 'lettersPending': return asc ? 'Fewest First' : 'Most First';
        default: return null;
      }
    }
  }),
  switchSection({ key: 'seen', label: 'New violations only' }),
  chipsSection({
    label: 'Reason',
    key: 'reasons',
    options: [
      { value: ViolationReason.noLicense, label: 'Not licensed' },
      { value: ViolationReason.expiredLicense, label: 'License expired' },
      { value: ViolationReason.inactiveLicense, label: 'License inactive' }
    ]
  }),
  segmentedSection({
    key: 'deferred',
    label: 'Deferral Status',
    options: [
      { value: DEFERRAL_FILTER_ACTIVE, label: 'Active' },
      { value: DEFERRAL_FILTER_PREVIOUS, label: 'Ended' },
      { value: DEFERRAL_FILTER_NOT_ACTIVE, label: 'Not active' },
      { value: DEFERRAL_FILTER_ALL, label: 'Any' }
    ]
  }),
  selectSection({
    key: 'deferralEndedWithinDays',
    label: 'Deferral Ended',
    placeholder: 'Any time',
    options: [
      { value: '7', label: 'Last 7 days' },
      { value: '30', label: 'Last 30 days' },
      { value: '90', label: 'Last 90 days' }
    ],
    visible: filters => filters.deferred === DEFERRAL_FILTER_PREVIOUS
  }),
  segmentedSection({
    key: 'letters',
    label: 'Pending letters',
    options: [
      { value: 'pending', label: 'Yes' },
      { value: 'no-pending', label: 'No' },
      { value: 'all', label: 'Any' }
    ]
  }),
  segmentedSection({
    key: 'sentLetters',
    label: 'Sent letters',
    options: [
      { value: 'sent', label: 'Yes' },
      { value: 'no-sent', label: 'No' },
      { value: 'all', label: 'Any' }
    ]
  })
];
